 import api from "../../api.js";

export async function fetchDepartments() {
  const res = await api.get("/api/departments");
  return res.data?.data || [];
}

export async function fetchInventoryByDepartment(departmentid, type) {
  const params = {};
  if (type) params.type = type;
  const res = await api.get(`/api/inventory/department/${departmentid}`, { params });
  return res.data?.data || [];
}

export async function fetchInventoryItem(sku) {
  const res = await api.get(`/api/inventory/item/${encodeURIComponent(sku)}`);
  return res.data?.data || null;
}

export async function fetchSuppliers(params = {}) {
  const qp = new URLSearchParams();
  if (params.departmentid != null) qp.set('departmentid', params.departmentid);
  const res = await api.get(`/api/suppliers${qp.toString() ? `?${qp.toString()}` : ''}`);
  return res.data?.data || [];
}

export async function updateInventoryItem(sku, payload) {
  const res = await api.put(`/api/inventory/item/${encodeURIComponent(sku)}`, payload);
  return res.data;
}
